import { Injectable } from '@angular/core';
import { CookieService } from 'ng2-cookies';

@Injectable()
export class CookieAdapterService {
  constructor(private extCookieService: CookieService) { }

  get(key: string): string {
    return this.extCookieService.get(key);
  }

  put(key: string, value: string, expires?: number | Date, path?: string, domain?: string, secure?: boolean): void {
    this.extCookieService.set(key, value, expires, path, domain, secure);
  }

  remove(key: string): void {
    this.extCookieService.delete(key);
  }
}



// WEBPACK FOOTER //
// ./ts/app/core/cookie-adapter.service.ts